import React from 'react';
import { Hero } from '../components/Hero';
import { ClassFormats } from '../components/ClassFormats';
import { WhyDesertSage } from '../components/WhyDesertSage';
import { Testimonials } from '../components/Testimonials';
import { SupportCTA } from '../components/SupportCTA';
import { ListenInsteadOfReading } from '../components/ListenInsteadOfReading';
export function HomePage() {
  return <>
      <Hero data-id="element-916" data-mp="2wzz9efcj5b9y" />
      <ClassFormats data-id="element-917" data-mp="2x1k6abmbh6az" />
      <WhyDesertSage data-id="element-918" data-mp="2x10m0o9725ts" />
      <Testimonials data-id="element-919" data-mp="2wy64p5lh914l" />
      <SupportCTA data-id="element-920" data-mp="2s1o4mj13dqyl" />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-16" data-id="element-921" data-mp="2s27av2hdqqws">
        <ListenInsteadOfReading data-id="element-922" data-mp="36qbvibzztci7" />
      </div>
    </>;
}